import React from 'react'
import styled from 'styled-components'

const Wrapper = styled.div<{ borderTop: boolean }>`
    display: flex;
    flex-direction: column;
    border-top: ${({ borderTop, theme }) => borderTop ? theme.name === "light" ? "1px solid " + theme.colors.colors.Black : "1px solid " + theme.colors.colors.Gold : "none"};
    border-bottom: 1px solid ${({ theme }) => theme.name === "light" ? theme.colors.colors.Black : theme.colors.colors.Gold};
`

const Title = styled.h2`
    text-transform: "uppercase";
    margin: 0;
    margin-right: 0.5rem;
    text-align: left;
`

const Description = styled.span`
    padding-left: 12px;
    font-weight: ${({ theme }) => theme.font.body.weight.regular};
    font-size: 1rem;
`

interface JobListItemProps {
    borderTop: boolean,
    title: string,
    subTitle: string,
    description: string,
    type?: string
}

export const buildApplicationUrl = (params: Record<string, string | undefined>) => {
    const searchParams = new URLSearchParams()

    Object.entries(params).forEach(([key, value]) => {
        if (!value) return

        const trimmedValue = value.trim()
        if (trimmedValue.length === 0) return

        const lowerValue = trimmedValue.toLowerCase()
        if (lowerValue === 'null' || lowerValue === 'undefined') return

        searchParams.set(key, trimmedValue)
    })

    const search = searchParams.toString()
    return `/karriere/aktuelle-stellen/online-bewerbung/${search ? `?${search}` : ''}`
}

const ListItemContainer = styled.div`
    display: flex;
    align-items: center;
    background: ${({ theme }) => theme.colors.backgrounds.body};
    border: 0;
    padding: 12px;
    outline: none;
`

export const ApplicationButton = styled.a`
    margin-left: auto;
    text-decoration: none;
    border-radius: 4px;
    font-size: 1rem;
    padding: 4px 36px;
    text-transform: uppercase;
    transition: all 0.3s;
    font-family: ${({ theme }) => theme.font.body.family};
    font-weight: ${({ theme }) => theme.font.body.weight.semiBold};
    background: ${({ theme }) => theme.name === 'light' ? '#000' : '#fff'};
    color: ${({ theme }) => theme.name === 'light' ? '#fff' : '#000'};
    cursor: pointer;
    &:hover {
        opacity: 0.8;
    }
`

const JobListItem = (props: JobListItemProps) => {
    return (
        <Wrapper borderTop={props.borderTop}>
            <ListItemContainer>
                <Title>{props.title}<span style={{ textTransform: "none" }}> {props.subTitle && props.subTitle}</span></Title>
                {
                    props.description && <Description>{props.description}</Description>
                }
                <ApplicationButton href={buildApplicationUrl({
                    job: [props.title, props.subTitle].filter(Boolean).join(' '),
                    desc: props.description,
                    type: props.type,
                })}>
                    Jetzt bewerben
                </ApplicationButton>
            </ListItemContainer>
        </Wrapper>
    )
}

export default JobListItem
